/**
 * PremiumEnquiry
 * 
 * @Author: Focci
 * @Date: 2024-10-28 09:29:21
 * @Last Modified by: Focci
 * @Last Modified time: 2024-10-28 09:29:21
 */

'use client'

import useLazyComponent from '@hook/useLazyComponent'
import useDialog from '@hook/useDialog'
import { useEffect, useImperativeHandle, forwardRef } from 'react'
import { CircularProgress } from '@comp/material'
import { useTranslations } from 'next-intl'

function PremiumEnquiryBody({ house, agentId, ...props }) {
  const { Wedget: MailConsultingAgency, getWedget, ready } = useLazyComponent()

  useEffect(() => {
    getWedget(() => import('@comp/page/property/floating-agent/MailConsultingAgency'))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if(!ready) {
    return (
      <div className="flex items-center justify-center h-48 w-full">
        <CircularProgress />
      </div>
    )
  }
  
  return (
    <MailConsultingAgency
      type={house ? 'house' : 'agent'}
      id={house?.id}
      agentId={agentId}
      body="Hi，I’d like to get a free appraisal on …"
      house={house}
      {...props}
    />
  )
}

function PremiumEnquiry(props, ref) {
  const te = useTranslations('enquiry')
  const { openDialog, closeDialog, Dialog } = useDialog()

  useImperativeHandle(ref, () => ({ openDialog }))
  
  return (
    <Dialog title={te('mailConsultingAgency')}>
      <PremiumEnquiryBody onSuccess={closeDialog} {...props} />
    </Dialog>
  )
}

export default forwardRef(PremiumEnquiry)
